import DocumentInput from './DocumentInput'
import { CourseContent, FileEntryBM } from '@bm-js/atlascloud-shared'

type Props = {
  content: CourseContent
  setContentData: (data: CourseContent['data']) => void
}

const CourseEditableDocument = ({ content, setContentData }: Props) => {
  const handleChange = (file?: FileEntryBM) => {
    setContentData({ file })
  }

  return (
    <div>
      <DocumentInput
        file={content.data.file.uuid ? content.data.file : null}
        onChange={handleChange}
      />
    </div>
  )
}

export default CourseEditableDocument
